import ReactDOM from "react-dom";
import "./Post.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

function PostImageModal({ imageUrl, onClose }) {
  return ReactDOM.createPortal(
    <div className="image-modal-overlay" onClick={onClose}>
      <div
        className="image-modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className="image-modal-close"
          onClick={onClose}
          aria-label="Close"
        >
          <FontAwesomeIcon icon={faTimes} />
        </button>
        <img
          src={imageUrl}
          alt="Full size preview"
          className="image-modal-image"
        />
      </div>
    </div>,
    document.body,
  );
}

export default PostImageModal;
